module.exports = __webpack_public_path__ + "static/favicon3-884fe3d4b14346f4a4ba1d04f2dbe1b9.png";